import TVProviderSelectorTemplate from "templates/liveTV/_messageTVProviderSelector.tpl";
import BaseLiveTVMessage from "components/messageBoxes/BaseLiveTVMessage";
import TVProviderDropBox from 'components/livetv/TVProviderDropBox';

export default class TVProviderSelectionLiveTVMessage extends BaseLiveTVMessage {

    constructor(parentContainer, data, copy, imageHost) {
        super(parentContainer, null);

        this.data = data;

        let tier1Providers = this.__filterProviderByTier(this.data, 1);
       
        this.template = TVProviderSelectorTemplate({providers: this.__sortedProviders(tier1Providers), title: copy.title, imageHost: imageHost});

        this.me = null;
        this.onProviderSelectedCallback = null;

        this.providerSearchBox = null;
    }

    onProviderSelected(callback) {
        this.onProviderSelectedCallback = callback;
    }


    show() {
        super.show();

        let self = this;
        for (let provider of this.me.querySelectorAll('.slate__provider__box > a')) {
            provider.addEventListener('click', function (e) {
                e.preventDefault();
                self.onProviderSelectedCallback(e.target.dataset.providerid);
            });
        }

        let tier2Providers = this.__filterProviderByTier(this.data, 2);
        this.providerSearchBox = new TVProviderDropBox(this.me.querySelector('#provider__select__box'), tier2Providers);
        this.providerSearchBox.onProviderSelected((providerId) => {
            self.onProviderSelectedCallback(providerId);
        });
    }

    /**
     * @param providers
     * @returns {*}
     * @private
     */
    __filterProviderByTier(providers, tier) {
        return providers.filter((p) => {
            return p.tier === tier;
        })
    }

    /**
     * @param providers
     * @returns {*}
     * @private
     */
     __sortedProviders(providers) {
        return providers.sort((a, b) => {
            return a.providerName.toLowerCase().localeCompare(b.providerName.toLowerCase());
        });
    }

}